const article = {
  slug: 'daily-close',
  title: 'Daily close',
  section: 'Money',
  body: `
# Daily close

**Reports -> Daily close** reconciles a day's takings:

1. Review the day's payments by method (cash, check, card, other).
2. Count the drawer against the cash total.
3. Post the close - it snapshots the day, notes discrepancies, and
   gives you a clean deposit record.

Run it every banking day; gaps show up while memories are fresh.
`,
};

export default article;
